<template>
  <div>
    <b-row class="mt-4 mb-2">
      <b-col xl="4" class="pt-6">
        <h4>Team Members</h4>
        <p class="small">Add your team members here. These members will be used in your ClarityNOW portal to associate with listings and transactions. Anyone whom would receive compensation on a sale should be added here.</p>
        <userpilot-flow :id="'1670277673hTvr4845'" :variant="'outline-primary'"></userpilot-flow>
      </b-col>
      <b-col xl="8">
        <b-card no-body>
          <b-card-header>
            <h3 class="mb-0">Current Members</h3>
          </b-card-header>
          <b-card-body>
            <b-form inline @submit.stop.prevent="addMember">
              <b-form-group class="mr-2">
                <label for="name" class="sr-only sr-only-focusable">Name:</label>
                <b-form-input size="sm" id="name" v-model="form.name" type="text" placeholder="Name" required></b-form-input>
              </b-form-group>

              <b-form-group class="mr-2">
                <label for="title" class="sr-only sr-only-focusable">Title:</label>
                <b-form-input size="sm" id="title" v-model="form.title" type="text" placeholder="Title" required></b-form-input>
              </b-form-group>

              <b-form-group class="mr-2">
                <label for="email" class="sr-only sr-only-focusable">Email:</label>
                <b-form-input size="sm" id="email" v-model="form.email" type="email" placeholder="Email" required></b-form-input>
              </b-form-group>

              <b-button size="sm" type="submit" variant="primary">Add Member</b-button>
            </b-form>
          </b-card-body>
          <b-table small id="members" :items="items" :fields="fields" :perPage="perPage" :currentPage="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive v-if="items">
            <template #cell(name)="row">
              <b-form-input size="sm" v-model="row.item.name" v-if="editable === row.index" required />
              <span v-else>{{ row.item.name }}</span>
            </template>

            <template #cell(title)="row">
              <b-form-input size="sm" v-model="row.item.title" v-if="editable === row.index" />
              <span v-else>{{ row.item.title }}</span>
            </template>

            <template #cell(email)="row">
              <b-form-input size="sm" v-model="row.item.email" type="email" v-if="editable === row.index" required />
              <span v-else>{{ row.item.email }}</span>
            </template>

            <template #cell(actions)="row">
              <b-button-group v-if="editable === row.index">
                <b-button size="sm" variant="success" @click="update(row.item)" :disabled="row.item.name && row.item.email ? false : true"><i class="fa fa-check"></i> Save</b-button>
                <b-button size="sm" variant="danger" @click="cancel" :disabled="row.item.name && row.item.email ? false : true"><i class="fa fa-times"></i> Cancel</b-button>
              </b-button-group>
              <b-button size="sm" variant="primary" @click="edit(row.index)" v-else><i class="fa fa-edit"></i> Edit</b-button>
            </template>

            <template #cell(active)="row">
              <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success text-center">
                <input type="checkbox" class="custom-control-input" :id="row.item.slug" :value="row.item.slug" v-model="activeMembers" @click="toggleActive(row.item)" :disabled="row.item.name && row.item.email ? false : true">
                <label class="custom-control-label" :for="row.item.slug"></label>
              </div>
            </template>
          </b-table>
          <loading-panel v-else></loading-panel>
          <b-card-footer>
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="members"></b-pagination>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import LoadingPanel from '@/components/LoadingPanel';
import errorsMixin from '@/mixins/errors-mixin';
import UserpilotFlow from '@/views/Components/UserpilotFlow';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel,
    UserpilotFlow
  },
  data: function() {
    return {
      team: null,
      form: {
        name: "",
        title: "",
        email: ""
      },
      fields: ['name', 'title', 'email', 'active', { key: 'actions', label: '' }],
      perPage: 10,
      currentPage: 1,
      sortBy: 'active',
      sortDesc: true,
      items: null,
      editable: null,
      activeMembers: [],
      howToUrl: null
    }
  },
  computed: {
    activeTeam() {
      return this.activeMembers;
    },
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    rows() {
      return this.items ? this.items.length : 0;
    }
  },
  methods: {
    async getTeam() {
      axios.get(this.userRoute + "/teams")
      .then(response => {
        this.team = response.data;

        if(this.team) {
          this.getMembers();
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getMembers() {
      axios.get(this.userRoute + "/members")
      .then(response => {
        this.items = response.data;
        this.items.forEach((member) => {
          if(member.active == 1) {
            this.activeMembers.push(member.slug);
          }
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    async addMember() {
      axios.post(this.userRoute + "/members", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.getMembers();
        this.$emit('getMembers');
        this.clearForm();
      })
      .catch(error => {
        this.error(error);
      });
    },
    edit(index) {
      this.editable = index;
    },
    async update(member) {
      axios.patch(this.userRoute + "/members/" + member.slug, {
        name: member.name,
        title: member.title,
        email: member.email,
        active: member.active
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.editable = null;
        this.getMembers();
        this.$emit('getMembers');
        this.clearForm();
      })
      .catch(error => {
        this.error(error);
      });
    },
    cancel() {
      this.editable = null;
    },
    clearForm() {
      this.form.name = "";
      this.form.title = "";
      this.form.email = "";
    },
    async toggleActive(member) {
      axios.patch(this.userRoute + "/members/" + member.slug, {
        name: member.name,
        title: member.title,
        email: member.email,
        active: (member.active == 0) ? 1 : 0
      })
      .then(response => {
        this.editable = null;
        this.getMembers();
        this.clearForm();
      })
      .catch(error => {
        this.error(error);
      });
    },
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
  },
  created() {
    this.getTeam();
  },
};
</script>